import { DEPLOY_STATUSES } from "../constants";

const { FAILURE , CANCELLED} = DEPLOY_STATUSES;
const REPO_NOT_FOUND = "Repo not found";

const getFirstFailureStep = (status) => {

  const failureEntry = status && Object.entries(status).find(
    ([_, value]) =>
      value.steps &&
      Array.isArray(value?.steps) &&
      value.steps.some((step) => step.conclusion === FAILURE || step.conclusion === CANCELLED )
  );
  
  if (failureEntry) {
    const [key, value] = failureEntry;
    const firstFailedStep = value?.steps.find(
      (step) => step.conclusion === FAILURE || step.conclusion === CANCELLED 
    );
    return `${key}: ${value?.status.toUpperCase()}\nDeployment failed during the '${
      firstFailedStep.name
    }' step`;
  }

  return REPO_NOT_FOUND;
};

export default getFirstFailureStep;
